
<template>
  <div class="Content">
    <div  :id="echartsId" class="bar" v-resize="resize"></div>
  </div>
</template>
<script>
import { getSlice } from "@/utils/index";
import uuidv1 from "uuid/v1";
export default {
  props: {
    barDate2: {
      //echarts数据
      type: Object, //类型对象
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      objdata: "",
      echartsId:uuidv1()

    };
  },
  created() {
  },
  watch: {
    barDate2: {
      handler(newVal, oldVal) {
        setTimeout(() => {
          this.objdata = this.initData(newVal);
          this.fillYearEcharts(this.objdata);
        }, 500);
      },
      deep: true
    }
  },
  mounted() {
    this.objdata = this.initData(this.barDate2);
    this.fillYearEcharts(this.objdata);
  },
  methods: {
    resize(){
      this.myChart && this.myChart.resize();
    },
    initData(curval) {
      let that = this
      let obj = {
        timeTitle: curval.timeTitle,
        x: curval.xdata,
        series: [
          {
            type: "bar",
            name: "电费",
            itemStyle: {
              color: function (params) {
                console.log('color', this)
                let colorList = [
                  ['#E8F8FF','#CCEEFF'],
                  ['#F4F4CE','#E6E6A1']
                ]
                let index = params.dataIndex
                return new that.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: colorList[index][0]
                }, {
                  offset: 1,
                  color: colorList[index][1]
                }])
              }
            },
            data: curval.data,
            label: {
              show: true,
              position: "top",
              color: "#8A9099"
            }
          }
        ]
      };
      return obj;
    },
    fillYearEcharts(obj) {
      let this_ = this;
      if (
        this_.myChart != null &&
        this_.myChart != "" &&
        this_.myChart != undefined
      ) {
        this_.myChart.dispose();
      }
      this.myChart = this.$echarts.init(document.getElementById(this.echartsId));
      var option = {
        title: {
          text: "力调电费比较分析",
          subtext: "查询时间：" + obj.timeTitle,
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          confine: true
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {}
          }
        },
        // color: ["#d4953e", "#78b1e9", "#6ea562", "#e8855b", "#DC143C"],
        grid: {
          left: "1%",
          right: "1%",
          bottom: "2%",
          top: "20%",
          show: true,
          borderColor: "#dce1e7",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: obj.x,
            axisLabel: {
              color: "#8A9099",
              fontSize: 16,
              fontFamily: "FZLTHJW",
              interval: 0
              // rotate:-30
            },
          }
        ],
        yAxis: [
          {
            type: "value",
          }
        ],
        series: obj.series
      };
      this_.myChart.setOption(option, true);
      if (this_.myChart) {
        window.addEventListener("resize", function() {
          this_.myChart.resize();
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.pagebox {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
// #bar{width:100%;height:calc(100% - 20px);overflow: hidden;}
// #bar {
//   width: 100%;
//   height: calc(100% - 10px);
//   overflow: hidden;
// }
.bar {
  width: 100%;
  height: calc(100% - 10px);
  overflow: hidden;
}
.Content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid #ccd7e8;
  border-radius: 10px;
}
.count {
  position: absolute;
  top: 2rem;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0 0 10px 2px #ccd7e8;
  box-sizing: border-box;
}
.countUl {
  list-style: none;
  overflow: hidden;
  display: flex;
  margin-left: 5%;
  margin: 0px;
  height: 20px;
  margin-top: 11px;
  padding-left: 26px;
}
.countUl li {
  font-size: 0.1rem;
  line-height: 1.2rem;
  box-sizing: border-box;
  margin-right: 10px;
  text-align: center;
  width: 100px;
}
.parentflex {
  position: relative;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
  padding-top: 1px;
}
.parentflex > p {
  width: 100%;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 1.2rem;
  padding-left: 1rem;
  font-weight: bold;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.content {
  position: absolute;
  top: 35px;
  bottom: 5px;
  left: 5px;
  right: 5px;
}
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  padding-top: 1px;
}
canvas {
  height: 100%;
}
</style>